// extracted by mini-css-extract-plugin
export default {"trout":"#4a5161","backToTop":"styles_backToTop__MbSf_","text":"styles_text__CJepA","icon":"styles_icon__NBhb2"};